// src/api/platforms.ts
import { opsHttp } from "../auth/apiClient.ts";
import type { PlatformDto } from "./dto.ts";

export async function getPlatforms<T = PlatformDto>(): Promise<T[]> {
  const { data } = await opsHttp.get<T[]>("/api/Platforms");
  return data ?? [];
}
